import * as React from "react";
import { Icon, IconName } from "@nju/icons";
import { BlockText, Circle } from "@nju/ui";

interface ITripodStepProps {
  iconName: IconName;
  badge: number;
}

export function TripodStep({
  children,
  iconName,
  badge,
}: React.PropsWithChildren<ITripodStepProps>) {
  return (
    <li className="flex p-2 break-inside-avoid-column from-tablet:py-4">
      <div className="relative pr-4">
        <span
          className="
            bg-cerulean text-white w-[25px] h-[25px] flex items-center justify-center rounded-full
            from-tablet:absolute from-tablet:top-[-10px] from-tablet:left-[-10px]
          "
        >
          {badge}
        </span>
        <div className="only-mobile:hidden">
          <Circle tone="daintree">
            <Icon height={20} name={iconName} tone="complementary" width={20} />
          </Circle>
        </div>
      </div>
      <BlockText size={{ "@onlyMobile": "m", "@fromTablet": "l" }}>
        {children}
      </BlockText>
    </li>
  );
}
